import { Fragment } from 'react'
import { Typography} from '@mui/material'
import { primaryTextColor, PRIMARY_BUTTON } from 'themes/theme'
import { useNavigate } from 'react-router-dom'
import { store } from 'reduxStore'
import ZendeskLink from 'components/Common/ZendeskLink'
import Button from 'components/Common/Button'

const UserContent = ({ content }) => {
  const navigate = useNavigate()
  const user = store.getState().userReducer.user

  const onClickStartNow = e => {
    e && e.preventDefault()
    navigate('/welcome')
  }

  const onClickFindNow = e => {
    e && e.preventDefault()
    navigate('/find')
  }

  return (
    <Fragment>
      <Typography
        component="p"
        sx={{
          fontWeight: 'bold',
          color: primaryTextColor,
          fontSize: '1.5rem',
        }}
      >
        {content}
      </Typography>
      <div style={{ marginTop: '30px' }}>
        {user.accountType === 'free' ? (
          <Button type={PRIMARY_BUTTON}  onClick={onClickStartNow}>
            {'Subscribe'}
          </Button>
        ) : (
          <Button type={PRIMARY_BUTTON}  onClick={onClickFindNow}>
            {'Find Now'}
          </Button>
        )}
      </div>
      <div style={{ marginTop: '200px' }}>
        <ZendeskLink />
      </div>
    </Fragment>
  )
}

export default UserContent
